import SignInActionManager from "../../../action_managers/sign_in";
import SignInPage from "./sign_in_page";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withPageTitle } from "../../lib/WithPageTitle";

function mapStateToProps(state) {
  return {
    isLoading: state.signIn.isLoading,
    hasError: state.signIn.hasError,
    errorMessage: state.signIn.errorMessage,
    user: state.user.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    submitSignIn: (formData, role) => {
      var manager = new SignInActionManager({
        ...formData,
        forRole: role,
      });
      return dispatch(manager.run());
    },
  };
}

const SignInPageWrapper = withRouter(connect(mapStateToProps, mapDispatchToProps)(SignInPage));

export default withPageTitle(SignInPageWrapper, "Sign In");
